<template>
  <div>
    <div class="renewing-membership">
      <div class="row">
        <div class="col-md-6">
          <h6>You are renewing the membership for</h6>
        </div>
        <div class="col-md-6 text-md-right text-sm-left">
          <el-button v-if="members.length == 2" type="text" @click="openRequestIndividual">Request individual membership</el-button>
        </div>
        <div class="col-md-12"><name-tiles showInitial :items="members" /></div>
      </div>
    </div>
    <div class="previous-year-membership" v-if="previousProducts.length > 0">
      <h6>Previous Year Membership Renewal</h6>
      <product-selection display="list" hideTitle noBorder :products="previousProducts" type="mandatory" @save-selection="updatePreviousProduct" />
    </div>
    <div class="renewing-membership membership-options">
      <div class="row">
        <div class="col-md-6 ">
          <h6>
            {{ configOptions['renewal-lable-membership-options'] }}
            <el-link type="info" :underline="false" @click="membershipDialogVisible = true">
              <i class="fas fa-info-circle" title=""></i>
            </el-link>
          </h6>
        </div>
        <div class="col-md-6 text-md-right text-sm-left">
          <el-button v-if="showConcession" type="text" @click="dialogVisible = true">Apply for concessional membership</el-button>
        </div>
        <div class="col-md-12 mb-1">
          <product-selection
            :display="standardProducts.length === 1 ? 'list' : 'grid'"
            :products="standardProducts"
            type="one"
            @save-selection="updateStandardProduct"
            :selected="standardCurrentSelected"
            hideDescription
          />
        </div>
      </div>
      <el-alert
        title="You have to choose one membership option"
        type="error"
        show-icon
        v-show="membershipRequired"
        @close="membershipRequired = false"
      />
    </div>
    <div class="previous-year-membership renew-membership" v-if="secondaryProducts.length > 0">
      <h6>Secondary Membership Renewal</h6>
      <product-selection
        display="list"
        hideTitle
        noBorder
        :products="secondaryProducts"
        type="any"
        @save-selection="updateSecondaryProduct"
        :selected="secondaryCurrentSelected"
      />
    </div>
    <div class="renewal-btn d-flex justify-content-end justify-content-md-center">
      <el-button type="primary" @click="nextStep">NEXT <i class="el-icon-arrow-right el-icon-right"></i></el-button>
    </div>
    <el-dialog class="dialog-popup" :title="configOptions['renewal-lable-membership-options']" :visible.sync="membershipDialogVisible">
      <p v-html="configOptions['renewal-info-membership-options']"></p>
    </el-dialog>
    <el-dialog title="Proof of Concession" :visible.sync="dialogVisible" v-loading="loading">
      <div class="dialog-concession">
        <p>Retired superannuants, Pensioners and Students must provide proof to get concession rates.</p>
        <div v-for="person in members" :key="person.id">
          <h6>{{ person.fullName }}</h6>
          <el-upload
            class="upload-demo"
            drag action=""
            :ref="'upload' + person.id"
            :auto-upload="false"
            :multiple="false"
            accept="image/jpeg,image/jpg,image/png">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
            <div class="el-upload__tip" slot="tip">jpg/png files with a size less than 500kb</div>
          </el-upload>
        </div>
        <el-checkbox v-model="pocChecked">I confirm that I am eligible for concession pricing</el-checkbox>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="formSubmit" :disabled="!pocChecked">Confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import NameTiles from '../_FormElements/NameTiles.vue';
import ProductSelection from '../_FormElements/ProductSelection/Index.vue';

export default {
  components: { NameTiles, ProductSelection },
  data() {
    return {
      pocChecked: false,
      loading: false,
      dialogVisible: false,
      membershipDialogVisible: false,
      membershipRequired: false,
    }
  },
  computed: {
    ...mapGetters('renewal', [
      'members',
      'membershipForm',
      'configOptions',
      'offerOptions',
      'previousProducts',
      'standardProducts',
      'secondaryProducts'
    ]),
    standardCurrentSelected() {
      return this.membershipForm.standardProducts?.['product-code'];
    },
    secondaryCurrentSelected() {
      return this.membershipForm.secondaryProducts?.['product-code'];
    },
    showConcession() {
      let showButton = this.offerOptions['show-concession-application'];
      if (this.standardProducts.some(p => p['product-code'].toLowerCase() === 'ylb')) {
        showButton = false;
      }

      return showButton;
    }
  },
  mounted() {
    this.setPayload({ membershipForm: { ...this.membershipForm, members: this.members }});
  },
  methods: {
    ...mapMutations('renewal', ['setPayload', 'setStep']),
    ...mapActions('renewal', ['getConfigurationSet', 'sendConcession']),

    openRequestIndividual() {
      this.$alert(this.configOptions['renewal-request-ind'], '', { dangerouslyUseHTMLString: true });
    },
    updatePreviousProduct(selected) {
      const product = this.previousProducts.find(p => p['product-code'] === selected[0]);
      this.setPayload({ membershipForm: { ...this.membershipForm, previousProducts: product } });
    },
    updateStandardProduct(selected) {
      const product = this.standardProducts.find(p => p['product-code'] === selected);
      this.setPayload({ 
        membershipForm: { ...this.membershipForm, standardProducts: product },
        jnrProduct: selected.toLowerCase() === 'jnr'
      });
    },
    updateSecondaryProduct(selected) {
      const product = this.secondaryProducts.find(p => p['product-code'] === selected[0]);
      this.setPayload({ membershipForm: { ...this.membershipForm, secondaryProducts: product } });
    },
    formSubmit() {
      let submitError = false;
      let base64Promise = []
      this.members.forEach((person) => {
        const file = this.$refs[`upload${person.id}`][0].uploadFiles[0].raw;
        const isLt500Kb = file.size / 1024 / 1024 < 0.5;
        if (!isLt500Kb) {
          this.$message.error(`The uploaded file size for ${person.fullName} can not exceed 500kb!`);
          submitError = true;
        } else {
          base64Promise.push(this.$convertBase64(file));
        }
      });

      if (!submitError && base64Promise.length > 0) {
        Promise.all(base64Promise)
        .then((base64Result) => {
          this.loading = true;
          this.sendConcession(base64Result).then((res) => {
            if (res) {
              location.reload();
            }

            this.loading = false;
          });
        })
        .catch((error) => {
          console.log(error)
        })
      }
    },
    nextStep() {
      if (!this.membershipForm.standardProducts) {
        this.membershipRequired = true;
      } else {
        this.setStep(2);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-concession {
  color: #333;
  word-break: break-word;
}
</style>